export default function getXBOXStoreGameLink(productId, region = 'us') {
  let regionString = 'en-US';

  if (region === 'eu') {
    regionString = 'de-DE';
  }

  return `https://www.microsoft.com/${regionString}/p/q/${productId}/`;
}
